<template>
    <div>
        <span v-if="review.content" class="text-sm link cursor-pointer" @click="showReviewModal = true">
            Відповісти
        </span>

        <Modal title="Надіслати вiдповідь" :show="showReviewModal" @close="showReviewModal = false">
            <ReplyForm :review="review" @closeModal="showReviewModal = false"/>
        </Modal>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import Modal from '@/Components/Modal.vue';
import ReplyForm from '@/Partials/Products/Comments/ReplyForm.vue';

export default defineComponent({
    components: { ReplyForm, Modal },
    props: {
        review: Object
    },
    data() {
        return {
            showReviewModal: false,
        }
    }
})
</script>
